import type { SkillStatus } from '../types';

/**
 * 已上架（published）优先排序。
 *
 * published 项排在最前，其余（draft / pending_review / unpublished）保持原有相对顺序。
 * 依赖 ES2019+ 稳定排序，不打乱各分组内部顺序；返回新数组，不修改入参。
 * 与列表页 getStatus 口径一致：status 缺省视为 published。
 */
export function sortPublishedFirst<T extends { status?: SkillStatus }>(items: readonly T[]): T[] {
  return [...items].sort((a, b) => publishedRank(a.status) - publishedRank(b.status));
}

function publishedRank(status?: SkillStatus): number {
  return (status || 'published') === 'published' ? 0 : 1;
}
